import { ILocalStorageValues } from "types/types";

export const useStorage = (key: string) => {
  let onboarding: ILocalStorageValues = {};

  const storagedValues = () => {
    try {
      const storage = localStorage.getItem("onboarding");
      if (storage) {
        onboarding = JSON.parse(storage);
      }
    } catch (error) {
      console.log("[useStorage]", error);
    }
  };
  storagedValues();
  const storageValue = onboarding[key];

  return {
    hasValue: !!onboarding,
    storageValue,
  };
};
